export const SERVER_TIME_ZONE = 'America/New_York';
export const SERVER_TIME_FORMATS = ['MM/DD/YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss'];

export function convertServerDateToLocalMoment(date, format = SERVER_TIME_FORMATS, userTimeZone) {
  if (userTimeZone) {
    return moment.tz(date, format, SERVER_TIME_ZONE).tz(userTimeZone);
  } else {
    return moment.tz(date, format, SERVER_TIME_ZONE).local();
  }
}

export function convertLocalDateToServerMoment(date, format, userTimeZone) {
  if (userTimeZone) {
    return moment.tz(date, format, userTimeZone).tz(SERVER_TIME_ZONE);
  } else {
    return moment(date, format).tz(SERVER_TIME_ZONE);
  }
}

export function convertUtcDateToUserTimezoneMoment(date, format, userTimeZone) {
  if (userTimeZone) {
    return moment.tz(date, format, 'UTC').tz(userTimeZone);
  } else {
    return moment.tz(date, format, 'UTC').local();
  }
}
